import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loader } from "storybook/internal/components";
import canclecircle from "../../../../assets/images/cancelcircle.svg";
import loader from "../../../../assets/images/Spinner2.svg";
import Button from "../../../../components/common/Button/Button";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import PolicyCard from "../../../../components/policyCard/policyCard";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import usePolicyCancellationFlow from "../../../../hooks/usePolicyCancellationFlow";
import { selectCrmCaseComplaintLoader } from "../../../../redux/features/crm/caseComplaintSlice";
import {
  getPolicyViewHeaderPartyResponse,
  getPolicyViewHeaderResponse,
} from "../../../../redux/features/policyDetailsSlice";
import { getClientSource } from "../../../../utils/getClientSource";
import PolicyCancellationMotorLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/policyCancellationMotorLayout";
import AlertComponent from "../../../motorInsurancePages/transferPolicyFlow/alertComponent";

const TravelConfirmCancellationPage = ({
  handleNavigationToPolicyOverview,
  confimedCancellation,
  selectedReasonOut,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const translate = useLanguageTranslate();
  const { handleNextSubstep, handlePrevStep } = usePolicyCancellationFlow();

  // Get policy detail. Call API if empty or check redux
  const policyDetailsInfo = useSelector(getPolicyViewHeaderResponse);
  const policyDetailsPartyInfo = useSelector(getPolicyViewHeaderPartyResponse);

  // Helper function to calculate days between dates
  const calculateTravelDays = () => {
    if (!policyDetailsInfo?.FromDateStr || !policyDetailsInfo?.ToDateStr)
      return "-- Days";

    try {
      const fromParts = policyDetailsInfo.FromDateStr.split("/");
      const toParts = policyDetailsInfo.ToDateStr.split("/");
      const fromDate = new Date(fromParts[2], fromParts[1] - 1, fromParts[0]);
      const toDate = new Date(toParts[2], toParts[1] - 1, toParts[0]);
      const daysDiff = Math.ceil((toDate - fromDate) / (1000 * 3600 * 24));
      // Travel duration should be return date - departure date + 1
      return daysDiff > 0 ? `${daysDiff + 1} Days` : "-- Days";
    } catch {
      return "-- Days";
    }
  };

  // Create travel policy card info (adapting motor structure for travel)
  const policyCardInfo = {
    ModelYear: "",
    Make: "Travel Policy", // Travel Policy
    Model: calculateTravelDays(), // X Days
    CPR: "",
    PolicyNumber: policyDetailsInfo?.PolicyNumber || "--",
    RegistrationNumber: "", // Not applicable for travel
    SumInsured: 0.0,
    PlanName: policyDetailsInfo?.PlanName || "--",
    ProductCode: "0204", // Travel insurance product code
    ProductName: "Travel",
    StartDate:
      policyDetailsInfo?.FromDateStr?.split(" ")[0]
        ?.split("/")
        ?.reverse()
        ?.join("-") || "--",
    EndDate:
      policyDetailsInfo?.ToDateStr?.split(" ")[0]
        ?.split("/")
        ?.reverse()
        ?.join("-") || "--",
    FromDateStr: policyDetailsInfo?.FromDateStr?.split(" ")[0] || "--",
    ToDateStr: policyDetailsInfo?.ToDateStr?.split(" ")[0] || "--",
    Branch: getClientSource(),
    MainChannel: "Direct Bahrain",
    Renewed: policyDetailsInfo?.IsRenewed,
    PolicyStatus: "Active",
    IsRenewable: false,
  };

  console.log("Selected reason from final page: ", selectedReasonOut);
  const isCaseLoading = useSelector(selectCrmCaseComplaintLoader);

  return (
    <PolicyCancellationMotorLayout
      backClickHandler={handlePrevStep}
      is_bottom_sticky_layout={false}
    >
      <div className="flex flex-col items-center mx-auto max-w-lg max767:p-5 max767:mb-8 max767:pt-0">
        <div className="flex justify-center items-center w-full">
          <div className=" p-0 w-full confirmCancellation">
            <TitleDescription
              title={translate("Confirm Cancellation", "تأكيد الإلغاء")}
              description={translate(
                "Review your policy details below to ensure you are fully informed before finalizing the cancellation of your policy.",
                "يُرجى مراجعة تفاصيل سياسة التأمين أدناه للتأكد من أنك على دراية تامة قبل إنهاء الإلغاء.",
              )}
            />
            <div className="flex flex-col items-center gap-2 self-stretch bg-[#F6F8F9] p-4 rounded-2xl mb-4 max767:p-0 max767:bg-white">
              <p className="text-[#48535B] text-base not-italic font-semibold leading-6 tracking-[-0.16px] gap-2 flex">
                <img src={canclecircle} alt="" />{" "}
                {translate(
                  "You are cancelling this policy",
                  "أنت تلغي هذه السياسة",
                )}
              </p>
              <PolicyCard
                className="mb-4"
                policy_bg_image={policyCardInfo.policy_bg_image}
                data={policyCardInfo}
                disableCardClick
              />
            </div>

            {/* Show selected cancellation reason */}
            {/* <div className="mb-4 p-4 bg-white border border-[#DDE2E4] rounded-[10px]">
              <p className="text-[#48535B] text-sm font-medium mb-2">
                {translate("Cancellation Reason:", "سبب الإلغاء:")}
              </p>
              <p className="text-[#1A2024] text-base font-semibold">
                {selectedReasonOut || translate("Not specified", "غير محدد")}
              </p>
            </div> */}

            <AlertComponent
              title={translate(
                "Please note that once you confirm cancellation, this request will be processed and cannot be reversed. Ensure all details are correct and that you understand the implications of proceeding.",
                "يرجى ملاحظة أنه بمجرد تأكيد الإلغاء، ستتم معالجة هذا الطلب ولا يمكن التراجع عنه. تأكد من أن جميع التفاصيل صحيحة وأنك تفهم الآثار المترتبة على المتابعة.",
              )}
            />
            <div className="max767:footer max767:bg-white max767:border-t-[#E5E9EB] max767:border-t max767:border-solid max767:mt-2 max767:w-full max767:py-2 flex max767:flex-col !gap-4 mt-4 max767:fixed max767:bottom-0 max767:w-full max767:p-4 max767:inset-x-0 ipad:items-center max767:inline-block max767:z-[9] rtl:grid rtl:grid-cols-2 max767:!flex">
              <Button
                label={translate("Keep Policy", "الإبقاء على السياسة")}
                onSubmit={handleNavigationToPolicyOverview}
                disabled={isCaseLoading}
                className={`flex flex-col items-center max-w-[100%] gap-2.5 flex-[1_0_0] border max767:text-sm bg-white text-[#1A2024] text-center text-lg not-italic font-semibold leading-6 tracking-[-0.18px] p-4 rounded-[10px] border-solid border-[#DDE2E4] hover:bg-[#F6F8F9] rtl:w-max max767:w-full max767:mb-4 max767:!h-[56px] max767:min-h-[56px] max767:!max-h-[56px] rtl:!w-full max767:!mb-1 ${isCaseLoading ? "opacity-50 cursor-not-allowed" : ""}`}
              />
              <Button
                label={
                  isCaseLoading ? (
                    <span className="h-[24px] w-[24px] loader flex items-center justify-center">
                      <img className="h-full w-full" src={loader} alt="loader" />
                    </span>
                  ) : (
                    translate("Confirm Cancellation", "تأكيد الإلغاء")
                  )
                }
                onSubmit={confimedCancellation}
                disabled={isCaseLoading}
                className={`flex w-[300px] max-w-[100%] max767:w-full max767:text-sm flex-col items-center gap-2.5 bg-[#CC0905] text-white text-center text-lg not-italic font-semibold leading-6 tracking-[-0.18px] p-4 rounded-[10px] canclebutton hover:bg-[#CC0905] rtl:w-max max767:w-full max767:!h-[56px] max767:min-h-[56px] max767:!max-h-[56px] rtl:!w-full ${isCaseLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                labelStyle="!text-white"
              />
            </div>
          </div>
        </div>
      </div>
    </PolicyCancellationMotorLayout>
  );
};

export default TravelConfirmCancellationPage;
